const shellProducts = [
  {
    name: "Shell Helix Ultra 0W-40",
    badge: "Бог экстремального холода",
    specs: ["API SP", "Porsche A40", "MB 229.5", "BMW LL-01"],
    desc: "Превосходный холодный пуск при экстремальных морозах. Максимальная защита двигателя в суровых российских условиях.",
    highlight: true,
  },
  {
    name: "Shell Helix Ultra X 5W-40",
    badge: "Абсолютный лидер",
    specs: ["API SP", "MB 229.5", "BMW LL-01"],
    desc: "Самое массовое полностью синтетическое масло. Идеальный баланс защиты и экономичности для большинства двигателей.",
    highlight: false,
  },
  {
    name: "Shell Helix Ultra X 5W-30",
    badge: "Король эффективности",
    specs: ["API SP", "MB 229.5", "BMW LL-01"],
    desc: "Баланс мощности и экономии топлива. Рекомендовано для современных высоконагруженных двигателей.",
    highlight: false,
  },
  {
    name: "Shell Helix Ultra ECT C2/C3 0W-30",
    badge: "Экологический пионер",
    specs: ["MB 229.52", "MB 229.51", "Porsche C30"],
    desc: "Совместимо с DPF (сажевым фильтром). Снижает выбросы без потери защитных свойств.",
    highlight: false,
  },
  {
    name: "Shell Helix Ultra SP 0W-20",
    badge: "Защита современных турбин",
    specs: ["API SP", "ILSAC GF-6A"],
    desc: "Разработано для современных турбированных двигателей с прямым впрыском. Максимальная топливная экономичность.",
    highlight: false,
  },
];

const industrialShell = [
  { name: "Shell Tellus", type: "Гидравлика", approvals: "Bosch Rexroth, Haitian", icon: "ri-settings-3-line" },
  { name: "Shell Omala", type: "Редукторы", approvals: "Flender, Gamesa", icon: "ri-tools-line" },
  { name: "Shell Corena", type: "Компрессоры", approvals: "ABB VTR турбокомпрессоры", icon: "ri-loader-4-line" },
  { name: "Shell Gadus", type: "Консистентные смазки", approvals: "Caterpillar, Liebherr", icon: "ri-oil-line" },
];

export default function ShellSection() {
  return (
    <section id="shell" className="bg-[#080C14] py-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-[2px] bg-[#C9A84C]"></div>
              <span className="text-[#C9A84C] text-xs font-semibold tracking-[0.3em] uppercase">Масла Shell · Гонконг</span>
            </div>
            <h2 className="text-white mb-4" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(32px, 4.5vw, 60px)", letterSpacing: "0.03em" }}>
              ОРИГИНАЛЬНЫЙ SHELL ИЗ ГОНКОНГА:<br />
              <span className="text-[#C9A84C]">100% ОРИГИНАЛ</span>
            </h2>
            <p className="text-gray-400 text-base max-w-2xl leading-relaxed">
              В условиях глобального рынка, переполненного подделками, <strong className="text-white">«Made in Hong Kong»</strong> — это гарантия качества Shell Global. Критически важно в условиях суровых русских зим. Только официально подтверждённые продукты.
            </p>
          </div>
          <div className="flex items-center gap-4 bg-[#0D1420] border border-[#C9A84C]/30 px-6 py-4 rounded-sm">
            <div className="w-12 h-12 flex items-center justify-center bg-[#C9A84C]/10 rounded-sm">
              <i className="ri-map-pin-2-line text-[#C9A84C] text-2xl"></i>
            </div>
            <div>
              <div className="text-white font-bold text-sm">Происхождение</div>
              <div className="text-[#C9A84C] text-lg font-black" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>HONG KONG</div>
              <div className="text-gray-500 text-xs">Shell Global Quality Standard</div>
            </div>
          </div>
        </div>

        {/* Real Shell Photo Banner — oil bottle full view */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-sm overflow-hidden border border-[#C9A84C]/20 mb-12">
          {/* Left — bottle photo, full height, object-contain to show full bottle */}
          <div className="relative bg-[#0A0F1A] flex items-center justify-center" style={{ minHeight: "380px" }}>
            <img
              src="https://storage.readdy-site.link/project_files/9f45cb21-4b77-4979-b082-2610d4bf0c89/6c174df5-f66e-49fe-ae5c-4c0b6675bad8_0W-40-1L.jpg?v=97856453bd713a41f1cfc9cddc965921"
              alt="Shell Helix Ultra 0W-40 1L — реальный товар Shell HK distributor YAXIN склад Гонконг"
              className="w-full h-full object-contain"
              style={{ maxHeight: "380px" }}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-[#0D1420]/60"></div>
            {/* Corner accents */}
            <div className="absolute top-4 left-4 w-7 h-7 border-t-2 border-l-2 border-[#C9A84C]/50"></div>
            <div className="absolute bottom-4 right-4 w-7 h-7 border-b-2 border-r-2 border-[#C9A84C]/50"></div>
          </div>
          {/* Right — text content */}
          <div className="bg-[#0D1420] p-10 flex flex-col justify-center">
            <div className="text-[#C9A84C] text-[10px] font-semibold tracking-[0.3em] uppercase mb-4">Реальный товар · Склад YAXIN · Гонконг</div>
            <div className="text-white font-black mb-4" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(28px, 3.5vw, 50px)", letterSpacing: "0.03em", lineHeight: 1 }}>
              SHELL HELIX ULTRA<br />
              <span className="text-[#C9A84C]">MADE IN HONG KONG</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Каждая партия проходит верификацию подлинности. Фото/видео отчёт (POP) предоставляется до оплаты основного инвойса. Напрямую от официального дистрибьютора в Гонконге.
            </p>
            <div className="flex flex-wrap gap-2 mb-6">
              {["0W-40", "X 5W-40", "X 5W-30", "ECT 0W-30", "SP 0W-20"].map((v) => (
                <span key={v} className="text-[#C9A84C] text-xs font-bold bg-[#C9A84C]/15 border border-[#C9A84C]/30 px-3 py-1.5 rounded-sm whitespace-nowrap">
                  Helix Ultra {v}
                </span>
              ))}
            </div>
            <div className="flex items-center gap-3 pt-6 border-t border-[#1E2A3A]">
              <div className="w-8 h-8 flex items-center justify-center border border-[#C9A84C]/40 rounded-sm">
                <i className="ri-shield-check-line text-[#C9A84C] text-sm"></i>
              </div>
              <span className="text-gray-400 text-xs">Белая таможня · ГТД/НДС · EAC · Честный ЗНАК</span>
            </div>
          </div>
        </div>

        {/* Shell Helix Products */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-12">
          {shellProducts.map((product) => (
            <div
              key={product.name}
              className={`relative p-6 rounded-sm border transition-all duration-300 hover:border-[#C9A84C]/50 ${
                product.highlight
                  ? "bg-gradient-to-br from-[#C9A84C]/10 to-[#0D1420] border-[#C9A84C]/50"
                  : "bg-[#0D1420] border-[#1E2A3A]"
              }`}
            >
              {product.highlight && (
                <div className="absolute top-4 right-4 bg-[#C9A84C] text-[#0A0F1A] text-[10px] font-black px-2 py-0.5 rounded-sm tracking-wide uppercase">
                  ТОП
                </div>
              )}
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center bg-[#C9A84C]/10 border border-[#C9A84C]/30 rounded-sm">
                  <i className="ri-drop-line text-[#C9A84C] text-lg"></i>
                </div>
                <div>
                  <div className="text-[#C9A84C] text-[10px] font-semibold tracking-[0.2em] uppercase">{product.badge}</div>
                </div>
              </div>
              <h3 className="text-white font-bold text-base mb-3" style={{ fontFamily: "'Oswald', sans-serif" }}>{product.name}</h3>
              <p className="text-gray-500 text-xs leading-relaxed mb-4">{product.desc}</p>
              <div className="flex flex-wrap gap-1.5">
                {product.specs.map((spec) => (
                  <span key={spec} className="text-[#C9A84C] text-[10px] font-semibold bg-[#C9A84C]/10 border border-[#C9A84C]/20 px-2 py-0.5 rounded-sm whitespace-nowrap">
                    {spec}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Industrial Shell */}
        <div className="bg-[#0D1420] border border-[#1E2A3A] rounded-sm p-8">
          <h3 className="text-white font-bold text-xl mb-6" style={{ fontFamily: "'Oswald', sans-serif" }}>
            Индустриальные решения Shell
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {industrialShell.map((item) => (
              <div key={item.name} className="flex items-start gap-3 p-4 bg-[#080C14] border border-[#1E2A3A] rounded-sm hover:border-[#C9A84C]/30 transition-colors">
                <div className="w-9 h-9 flex items-center justify-center border border-[#C9A84C]/30 rounded-sm flex-shrink-0">
                  <i className={`${item.icon} text-[#C9A84C] text-base`}></i>
                </div>
                <div>
                  <div className="text-white font-semibold text-sm">{item.name}</div>
                  <div className="text-gray-500 text-xs mb-1">{item.type}</div>
                  <div className="text-gray-600 text-[10px]">Одобрено: {item.approvals}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="mt-8 text-center">
          <a
            href="#contact"
            className="inline-flex items-center gap-3 bg-[#C9A84C] hover:bg-[#b8943d] text-[#0A0F1A] font-bold text-sm px-8 py-4 rounded-sm tracking-wide uppercase transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-list-3-line text-base"></i>
            Запросить B2B прайс-лист на масла Shell
          </a>
        </div>
      </div>
    </section>
  );
}
